import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  handleAddLocationsBySwitch,
  handleAddMachinesBySwitch,
  handleAddSpecificLocationsBySwitch,
  handleLocationSelectBySwitch,
  handleMachineSelectBySwitch,
  handleSelectAllBySwitch,
  handleSelectedOneBySwitch,
  handleSpecificLocationSelectBySwitch,
  selectMCBySwitch,
} from "shared/slice/masterControlBySwitchSelectSlice";

import {
  handleAddLocationsByLocation,
  handleAddMachinesByLocation,
  handleAddSpecificLocationsByLocation,
  handleLocationSelectByLocation,
  handleMachineSelectByLocation,
  handleSelectAllByLocation,
  handleSelectedOneByLocation,
  handleSpecificLocationSelectByLocation,
  selectMCByLocation,
} from "shared/slice/masterControlSelectByLocationSlice";

import styled, { css } from "styled-components";
import {
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentSpaceBetween,
  layerA,
  layerA180Deg,
  layerBDark,
  layerCLighter,
} from "shared/styles/commonStyles";

import SelectOptions from "features/masterControl/components/controls/mainSelection/SelectOptions";
import SelectSubOptions from "features/masterControl/components/controls/mainSelection/SelectSubOptions";
import {
  selectLocationsHandler,
  selectMachinesHandler,
  selectSpecificLocationsHandler,
  unselectAllMachinesHandler,
} from "shared/hooks/useSelectSwitchesDispatches";
import { useSelectBoxArrowsState } from "shared/hooks/useSelectBoxArrowsState";
import {
  getAllSpecificLocationNames,
} from "shared/helpers/helpers";
import selectBoxResetHandler from "shared/helpers/ess-tgs-tes-mc/selectBoxResetHandler";
import { selectAllHandler } from "shared/helpers/ess-tgs-tes-mc/select_box_logic/selectAllHandler";
import { selectAllDispatchHandler } from "shared/helpers/ess-tgs-tes-mc/select_box_dispatchers/selectAllDispatchHandler";
import { selectLocationHandler } from "shared/helpers/ess-tgs-tes-mc/select_box_logic/selectLocationHandler";
import { selectLocationDispatchHandler } from "shared/helpers/ess-tgs-tes-mc/select_box_dispatchers/selectLocationDispatchHandler";
import { selectSpecificLocationHandler } from "shared/helpers/ess-tgs-tes-mc/select_box_logic/selectSpecificLocationHandler";
import { selectSpecificLocationDispatchHandler } from "shared/helpers/ess-tgs-tes-mc/select_box_dispatchers/selectSpecificLocationDispatchHandler";
import { selectMachineHandler } from "shared/helpers/ess-tgs-tes-mc/select_box_logic/selectMachineHandler";
import { selectMachineDispatchHandler } from "shared/helpers/ess-tgs-tes-mc/select_box_dispatchers/selectMachineDispatchHandler";

const SelectMachineItems = ({
  handleClose,
  data,
  dataE,
  swtName,
  name,
  scope,
  isMobile,
  specificLocation,
}) => {
  const { trackSpecLocationArrowState, trackArrowState, specificLocations } =
    useSelectBoxArrowsState(data);

  const [isSpecLocationArrowDown, setIsSpecLocationArrowDown] = useState(
    trackSpecLocationArrowState
  );
  const [isArrowDown, setIsArrowDown] = useState(trackArrowState);
  const [specificLocationsNameList, setSpecificLocationsNameList] = useState(
    []
  );
  const [isSelected, setIsSelected] = useState(false);
  const dispatch = useDispatch();

  let locations = Object.keys(data);

  let machinesArr;
  if (data && data[scope] && !data[scope].isSpecificLocation) {
    machinesArr = Object.keys(data[scope].devices);

  }



  const buttons = isMobile
    ? name === "shutOff"
      ? ["clear", "apply"]
      : ["clear", "select"]
    : ["clear", "select"];
  const mCBySwitch = useSelector(
    scope === "switch" ? selectMCBySwitch : selectMCByLocation
  );
  const {

    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,

    selectedLocations,
    selectedSpecificLocations,
    selectedMachines,
  } =
    name === "instantHeat"
      ? mCBySwitch.instantHeat
      : name === "snowSensor"
      ? mCBySwitch.snowSensor
      : name === "windFactor"
      ? mCBySwitch.windFactor
      : name === "optionalConstant"
      ? mCBySwitch.optionalConstant
      : name === "heatingSchedule"
      ? mCBySwitch.heatingSchedule
      : name === "ats"
      ? mCBySwitch.ats
      : name === "shutOff"
      ? mCBySwitch.shutOff
      : mCBySwitch.fanOnly;
  useEffect(() => {
    const result = getAllSpecificLocationNames(data);
    setSpecificLocationsNameList(result);
  }, [data]);
  const switchCountHandler = (machines, selectOneFC) => {
    let selectedSwtNumber = 0;
    machines.forEach((location) =>
      location.forEach((machine) => {
        if (typeof machine === "object") {
          machine.forEach((el) => {
            if (el) {
              selectedSwtNumber += 1;
            }
          });
        } else {
          if (machine) {
            selectedSwtNumber += 1;
          }
        }
      })
    );
    dispatch(
      selectOneFC({
        controller: name,
        selectedOne: `${selectedSwtNumber} switches`,
      })
    );
  };


  const handleOnClick = (button) => {
    if (button === buttons[1]) {

      let switchData;



      switchData = data;

      scope === "switch"
        ? switchCountHandler(isMachineSelected, handleSelectedOneBySwitch)
        : switchCountHandler(isMachineSelected, handleSelectedOneByLocation);




      if (isAllSelected) {



        scope === "switch"
          ? dispatch(
              handleSelectedOneBySwitch({
                controller: name,
                selectedOne: "all",
              })
            )
          : dispatch(
              handleSelectedOneByLocation({
                controller: name,
                selectedOne: "all",
              })
            );
        if (specificLocation) {

          const allMachines = Object.keys(
            switchData[scope][specificLocation]
          ).map((machineName) => [scope, specificLocation, machineName]);

          selectMachinesHandler(allMachines, swtName, switchData, dispatch);
        }














        selectLocationsHandler(locations, swtName, switchData, dispatch);

      } else if (isLocationSelected.indexOf(true) !== -1) {

        selectLocationsHandler(
          selectedLocations,
          swtName,
          switchData,
          dispatch
        );


        if (selectedSpecificLocations.length > 0) {
          selectSpecificLocationsHandler(
            selectedSpecificLocations,
            swtName,
            switchData,
            dispatch
          );
        }

        if (selectedMachines.length > 0) {

          selectMachinesHandler(
            selectedMachines,
            swtName,
            switchData,
            dispatch
          );
        }
      } else if (isSpecificLocationSelected.length > 0) {

        selectSpecificLocationsHandler(
          selectedSpecificLocations,
          swtName,
          switchData,
          dispatch
        );


        if (selectedMachines.length > 0) {
          selectMachinesHandler(
            selectedMachines,
            swtName,
            switchData,
            dispatch
          );
        }
      } else if (selectedMachines.length > 0) {

        selectMachinesHandler(selectedMachines, swtName, switchData, dispatch);
      } else if (!isSelected) {
        scope === "switch"
          ? dispatch(
              handleSelectedOneBySwitch({ controller: name, selectedOne: null })
            )
          : dispatch(
              handleSelectedOneByLocation({
                controller: name,
                selectedOne: null,
              })
            );
      }

      handleClose();
    } else {
      let switchData;



      switchData = data;

      const { locationList, specificLocationList, machineList } =
        selectBoxResetHandler(switchData);






















      const resetObj = { controller: name, arr: [] };
      const locationResetObj = { controller: name, arr: locationList };
      const specificLocationResetObj = {
        arr: specificLocationList,
        controller: name,
      };
      const machineResetObj = { controller: name, arr: machineList };

      if (scope === "switch") {

        dispatch(handleSelectAllBySwitch({ controller: name, status: false }));
        dispatch(
          handleSelectedOneBySwitch({ controller: name, selectedOne: null })
        );


        dispatch(handleAddLocationsBySwitch(resetObj));

        dispatch(handleAddSpecificLocationsBySwitch(resetObj));

        dispatch(handleAddMachinesBySwitch(resetObj));


        dispatch(handleLocationSelectBySwitch(locationResetObj));

        if (specificLocationList.length > 0) {
          dispatch(
            handleSpecificLocationSelectBySwitch(specificLocationResetObj)
          );
        }

        dispatch(handleMachineSelectBySwitch(machineResetObj));
      } else {

        dispatch(
          handleSelectAllByLocation({ controller: name, status: false })
        );
        dispatch(
          handleSelectedOneByLocation({ controller: name, selectedOne: null })
        );


        dispatch(handleAddLocationsByLocation(resetObj));

        dispatch(handleAddSpecificLocationsByLocation(resetObj));

        dispatch(handleAddMachinesByLocation(resetObj));


        dispatch(handleLocationSelectByLocation(locationResetObj));


        if (specificLocationList.length > 0) {
          dispatch(
            handleSpecificLocationSelectByLocation(specificLocationResetObj)
          );
        }


        dispatch(handleMachineSelectByLocation(machineResetObj));
      }

      unselectAllMachinesHandler(locations, swtName, data, dispatch);
    }
  };

  const turnOffParents = (locationIdx) => {
    const locationArr = [...isLocationSelected];
    locationArr[locationIdx] = false;
    const remainingLocations = selectedLocations.filter(
      (el) => el !== locations[locationIdx]
    );

    if (scope === "switch") {
      dispatch(handleSelectAllBySwitch({ controller: name, status: false }));
      dispatch(
        handleLocationSelectBySwitch({ controller: name, arr: locationArr })
      );
      dispatch(
        handleAddLocationsBySwitch({
          controller: name,
          arr: remainingLocations,
        })
      );
    } else {
      dispatch(handleSelectAllByLocation({ controller: name, status: false }));
      dispatch(
        handleLocationSelectByLocation({ controller: name, arr: locationArr })
      );
      dispatch(
        handleAddLocationsByLocation({
          controller: name,
          arr: remainingLocations,
        })
      );
    }
  };


  const handleSelect = (option, machine, extraOption, machineIndex) => {
    setIsSelected(true);
    let switchData;



    switchData = data;


    if (option === "all") {

      const { locationList, specificLocationList, machineList, select } =
        selectAllHandler(
          switchData,
          name,
          isLocationSelected,
          isSpecificLocationSelected,
          isAllSelected
        );

      setIsSelected(select);

      selectAllDispatchHandler(
        dispatch,
        scope,
        name,
        locationList,
        specificLocationList,
        machineList,
        select
      );
    } else if (option !== "all" && machine === undefined) {


      const {
        locationList,
        specificLocationList,
        machineList,
        newSelectedLocations,
        select,
      } = selectLocationHandler(
        switchData,
        option,
        locations,
        isLocationSelected,
        isMachineSelected,
        selectedLocations
      );

      setIsSelected(select);

      if (!select) {
        dispatch(
          scope === "switch"
            ? handleSelectAllBySwitch({ controller: name, status: false })
            : handleSelectAllByLocation({ controller: name, status: false })
        );
      }

      selectLocationDispatchHandler(
        dispatch,
        scope,
        name,
        locationList,
        specificLocationList,
        machineList,
        newSelectedLocations
      );
    }

    else if (option !== "all" && machine === "isSpecificLocation") {

      const {
        specificLocationList,
        machineList,
        newSpecificLocations,
        select,
        locationIndex,
      } =
        selectSpecificLocationHandler(
          option,
          machineIndex,
          extraOption,
          locations,
          isSpecificLocationSelected,
          isMachineSelected,
          specificLocations,
          selectedSpecificLocations
        );

      setIsSelected(select);

      if (!select) {
        turnOffParents(locationIndex);
      }

      selectSpecificLocationDispatchHandler(
        dispatch,
        scope,
        name,
        specificLocationList,
        machineList,
        newSpecificLocations
      );
    } else {

      const {
        locationIdx,
        specLocationIdx,
        machineIdx,
        newSelectedMachine,
        select,
      } =
        selectMachineHandler(
          option,
          machine,
          extraOption,
          switchData,
          selectedMachines,
          isMachineSelected
        );

      setIsSelected(select);

      if (!select) {
        turnOffParents(locationIdx);
      }

      selectMachineDispatchHandler(
        dispatch,
        scope,
        name,
        extraOption,
        locationIdx,
        specLocationIdx,
        machineIdx,
        newSelectedMachine,
        select
      );
    }
  };

  return (
    <>
      {isMobile ? (
        <Wrapper isMobile={isMobile} isSmall={scope !== "switch"}>
          <SectionOptions isMobile={isMobile} isSmall={scope !== "switch"}>
            <SelectOptions
              isSmall={scope !== "switch"}
              isMobile={isMobile}
              option="all"
              handleSelect={handleSelect}
              isSelected={isAllSelected}
            />



            {scope !== "switch" &&
              locations.map((location, index) => {
                return (
                  <SelectOptions
                    isMobile={isMobile}
                    key={index}
                    index={index}
                    option={location}
                    data={data[location]}
                    newData={data}
                    handleSelect={handleSelect}
                    isSelected={isLocationSelected[index]}
                    isMachineSelected={
                      isMachineSelected[index] && isMachineSelected[index]
                    }
                    isArrowDown={isArrowDown}
                    setIsArrowDown={setIsArrowDown}
                    allSpecificLocationsName={specificLocationsNameList}
                    isSpecificLocationSelected={isSpecificLocationSelected}
                    isSpecLocationArrowDown={isSpecLocationArrowDown}
                    setIsSpecLocationArrowDown={setIsSpecLocationArrowDown}
                  />
                );
              })}





          </SectionOptions>

          <SectionButtons isMobile={isMobile} isSmall={scope !== "switch"}>
            {buttons.map((button, index) => (
              <ButtonWrapper
                key={index}
                onClick={() => handleOnClick(button)}
                isMobile={isMobile}
                isSmall={scope !== "switch"}
              >
                <ButtonHole isMobile={isMobile} isSmall={scope !== "switch"}>
                  <ButtonInner isMobile={isMobile} isSmall={scope !== "switch"}>
                    <ButtonTop isMobile={isMobile} isSmall={scope !== "switch"}>
                      {button}
                    </ButtonTop>
                  </ButtonInner>
                </ButtonHole>
              </ButtonWrapper>
            ))}
          </SectionButtons>
        </Wrapper>
      ) : (
        <Wrapper isMobile={isMobile} isSmall={scope !== "switch"}>
          <ScrollWrapper>
            <SectionOptions isMobile={isMobile} isSmall={scope !== "switch"}>
              <SelectOptions
                isSmall={scope !== "switch"}
                isMobile={isMobile}
                option="all"
                handleSelect={handleSelect}
                isSelected={isAllSelected}
              />

              {locations &&
                !machinesArr &&
                locations.map((location, index) => {
                  return (
                    <SelectOptions
                      isMobile={isMobile}
                      key={index}
                      index={index}
                      option={location}
                      data={data[location]}
                      newData={data}
                      handleSelect={handleSelect}
                      isSelected={isLocationSelected[index]}
                      isMachineSelected={
                        isMachineSelected[index] && isMachineSelected[index]
                      }
                      isArrowDown={isArrowDown}
                      setIsArrowDown={setIsArrowDown}
                      allSpecificLocationsName={specificLocationsNameList}
                      isSpecificLocationSelected={isSpecificLocationSelected}
                      isSpecLocationArrowDown={isSpecLocationArrowDown}
                      setIsSpecLocationArrowDown={setIsSpecLocationArrowDown}
                    />
                  );
                })}


              {}

              {machinesArr &&
                machinesArr?.map((machine, index) => {
                  return (
                    <SelectSubOptions
                      isMobile={isMobile}
                      key={Math.random() * 10000}
                      location={scope}
                      machine={machine}
                      handleSelect={handleSelect}
                      isSelected={
                        isMachineSelected &&
                        isMachineSelected[0] &&
                        isMachineSelected[0][index]
                      }
                      scope={scope}
                    />
                  );
                })}
            </SectionOptions>
          </ScrollWrapper>

          <SectionButtons isMobile={isMobile} isSmall={scope !== "switch"}>
            {buttons.map((button, index) => (
              <ButtonWrapper
                key={index}
                onClick={() => handleOnClick(button)}
                isMobile={isMobile}
                isSmall={scope !== "switch"}
              >
                <ButtonHole isMobile={isMobile} isSmall={scope !== "switch"}>
                  <ButtonInner isMobile={isMobile} isSmall={scope !== "switch"}>
                    <ButtonTop isMobile={isMobile} isSmall={scope !== "switch"}>
                      {button}
                    </ButtonTop>
                  </ButtonInner>
                </ButtonHole>
              </ButtonWrapper>
            ))}
          </SectionButtons>
        </Wrapper>
      )}
    </>
  );
};

export default SelectMachineItems;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 5rem;

  ${flexDirectionColumn}

  ${(p) =>
    p.isMobile &&
    css`
      height: auto;
    `};
`;

const ScrollWrapper = styled.div`
  height: 100px;
  width: 100%;
  border-radius: 14px 8px 8px 14px;
  ${layerBDark};
  box-shadow: inset 0px 0px 6px #000000;
  padding: 2px;
  margin-bottom: 4rem;
`;
const SectionOptions = styled.div`
  height: 96px;
  width: 100%;

  scroll-behavior: smooth;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 10px;
    border: 1px solid #ffffff;
    border-radius: 13px;
  }
  ::-webkit-scrollbar-track {
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 13px;
    border: 1.5px solid transparent;
    background-clip: padding-box;
    height: 40%;
  }

  ::-webkit-scrollbar-button:start:decrement {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url("/images/scrollbar-button-start.svg");
  }
  ::-webkit-scrollbar-button:end:increment {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url("/images/scrollbar-button-end.svg");
  }

  ${(p) =>
    p.isMobile &&
    css`
      ::-webkit-scrollbar {
        display: none;
      }
      height: auto;
      max-height: 223px;
      width: ${(p) => (p.isSmall ? "287px" : `298px`)};
      border-radius: 18px;
      ${layerA}
      ${flexDirectionColumn};
      padding: 4px 0;
      margin-bottom: 4px;
    `}
`;

const SectionButtons = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween}
  ${(p) =>
    p.isMobile &&
    css`
      ${(p) =>
        p.isSmall
          ? css`
              width: 287px;
            `
          : css`
              width: 298px;
            `}
    `}
`;

const ButtonWrapper = styled.button`
  width: 84px;
  height: 27px;
  border-radius: 18px;

  ${layerBDark}
  ${flexBoxCenter}
  ${(p) =>
    p.isMobile &&
    css`
      border-radius: 27px;
      ${(p) =>
        p.isSmall
          ? css`
              width: 130px;
              height: 54px;
            `
          : css`
              width: 147px;
              height: 54px;
            `}
    `}
`;
const ButtonHole = styled.div`
  width: 82px;
  height: 25px;
  border-radius: 25px;
  ${layerA180Deg}
  ${flexBoxCenter}
  ${(p) =>
    p.isMobile &&
    css`
      border-radius: 26px;
      ${(p) =>
        p.isSmall
          ? css`
              width: 128px;
              height: 52px;
            `
          : css`
              width: 145px;
              height: 52px;
            `}
    `}
`;
const ButtonInner = styled.div`
  width: 74px;
  height: 17px;
  border-radius: 18px;
  ${layerCLighter}
  ${flexBoxCenter}
  ${(p) =>
    p.isMobile &&
    css`
      border-radius: 23px;
      ${(p) =>
        p.isSmall
          ? css`
              width: 118px;
              height: 42px;
            `
          : css`
              width: 135px;
              height: 42px;
            `}
    `}
`;
const ButtonTop = styled.div`
  width: 72px;
  height: 15px;
  border-radius: 25px;
  font-size: 10px;

  ${layerA180Deg}
  ${flexBoxCenter}
  ${(p) =>
    p.isMobile &&
    css`
      border-radius: 25px;
      font-size: 14px;
      letter-spacing: 1.4px;
      ${(p) =>
        p.isSmall
          ? css`
              width: 116px;
              height: 40px;
            `
          : css`
              width: 133px;
              height: 40px;
            `}
    `}
`;
